import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}) => {
  const baseStyles = "inline-flex items-center justify-center border font-medium rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 min-h-[44px] sm:min-h-0";

  const sizes = {
    sm: "px-3 py-1.5 text-sm gap-1.5",
    md: "px-4 py-2 text-sm gap-2",
    lg: "px-6 py-3 text-base gap-2",
  };

  const variants = {
    primary: "border-transparent text-white bg-primary-600 hover:bg-primary-500 hover:shadow-[0_0_20px_rgba(2,132,199,0.5)] focus:ring-primary-500",
    secondary: "border-transparent text-primary-300 bg-primary-900/30 hover:bg-primary-900/50 focus:ring-primary-500",
    outline: "border-neutral-700 text-neutral-200 bg-transparent hover:bg-neutral-800 hover:text-white hover:border-neutral-500 focus:ring-neutral-500"
  };

  const widthStyles = fullWidth ? "w-full" : "";

  return (
    <button
      className={`${baseStyles} ${sizes[size]} ${variants[variant]} ${widthStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};